import { Badge } from "@/components/ui/Badge";
import { Show } from "solid-js";
import { ActionDropdown, ActionDropdownMenuItem } from "../../components/ui/actions/ActionDropdown";

export const getPaymentColumns = ({ onClear, onRecordPayment }) => {

  return [
    {
      title: 'Date',
      key: 'date',
      sort: true,
      render: (row) => row.date
    },
    {
      title: 'Appointment',
      key: 'appointment',
      sort: false,
      render: (row) => row.appointment
    },
    {
      title: 'Patient',
      key: 'patient',
      sort: false,
      render: (row) => row.patient
    },
    {
      title: 'Fees',
      key: 'fees',
      sort: true,
      render: (row) => row.fees
    },
    {
      title: 'Paid',
      key: 'paid',
      sort: true,
      render: (row) => row.paid
    },
    {
      title: 'Balance',
      key: 'balance',
      sort: false,
      render: (row) => row.balance
    },
    {
      title: 'Status',
      key: 'status',
      sort: false,
      render: (row) => (
        <Badge variant={row.status === 'Paid' ? 'success' : 'warning'}>
          {row.status}
        </Badge>
      )
    },
    {
      title: '',
      isPlaceholder: true,
      key: null,
      render: (row) => (
        <Show when={row.status === 'Pending'}>
          <div class="flex gap-2 items-center">
            <ActionDropdown asIcon>
              <ActionDropdownMenuItem
                icon="carbon:checkmark-filled"
                onClick={() => onClear(row.key)}
              >
                Clear Payment
              </ActionDropdownMenuItem>
              <ActionDropdownMenuItem
                icon="carbon:currency-dollar"
                onClick={() => onRecordPayment(row.key)}
              >
                Record Payment
              </ActionDropdownMenuItem>
            </ActionDropdown>
          </div>
        </Show>
      )
    },
  ];
}
